import React from 'react';
import { Icon } from '@goodfynd/react-web.lib.ui';

import useUserExists from '../../../hooks/useUserExists';

import type { AuthorizedEmailCheckProps } from './types';
export function AuthorizedEmailCheck({
  notFoundIcon = 'caution',
  notFoundLabel = 'This user has not created an account yet',
  userId,
  ...props
}: AuthorizedEmailCheckProps) {
  const { exists, isFetching } = useUserExists(userId);

  if (exists) {
    return null;
  }

  return (
    <Icon
      color={exists === false ? 'TextIconDanger' : undefined}
      label={isFetching ? 'Checking for user account...' : notFoundLabel}
      name={isFetching ? 'person' : notFoundIcon}
      size={16}
      {...props}
    />
  );
}
